import React from 'react';

import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesSettingsLayout/CapsulesSettingsLayout.module.scss';

export interface CapsulesSettingsLayoutProps {
  header: React.ReactNode;
  banner?: React.ReactNode;
  main: React.ReactNode;
}

export const CapsulesSettingsLayout: React.FC<CapsulesSettingsLayoutProps> = ({
  header,
  banner,
  main,
}) => {
  return (
    <div className={styles.screenRoot}>
      {header}
      {banner}
      {main}
    </div>
  );
};
